import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useI18n } from "../../i18n/LanguageContext";
import { Badge } from "../../components/ui/badge";
import { toast } from "sonner";

export default function SuperAdminSparky() {
  const { t } = useI18n();
  const [rows, setRows] = useState(null);
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    api.saSparky().then(setRows).catch((e) => { toast.error(e.message); setRows([]); });
  }, []);

  return (
    <div className="space-y-6" data-testid="sa-sparky-page">
      <header>
        <div className="text-xs font-bold uppercase tracking-widest text-[#F72585]">{t("superadmin.title")}</div>
        <h1 className="text-3xl md:text-4xl font-black tracking-tight">{t("superadmin.sparky")}</h1>
        <div className="text-sm text-black/50 mt-1">Emails auto-redacted. Most recent 50.</div>
      </header>

      {rows === null ? (
        <div className="text-black/50">{t("superadmin.loading")}</div>
      ) : rows.length === 0 ? (
        <div className="rounded-2xl border-2 border-dashed border-black/10 p-8 text-center text-black/50">{t("superadmin.empty")}</div>
      ) : (
        <div className="space-y-3">
          {rows.map((c) => (
            <div key={c.conversation_id} className="rounded-2xl bg-white border border-black/5 p-4"
                 data-testid={`sa-sparky-conv-${c.conversation_id}`}>
              <button onClick={() => setExpanded({ ...expanded, [c.conversation_id]: !expanded[c.conversation_id] })}
                      className="w-full flex items-center justify-between gap-3 text-start">
                <div className="flex-1 min-w-0">
                  <div className="font-bold truncate">{c.conversation_id}</div>
                  <div className="text-xs text-black/50">user {c.user_id} · course {c.course_id} · {(c.messages || []).length} msgs</div>
                </div>
                <Badge className="text-[10px]">{c.updated_at?.slice(0, 10)}</Badge>
              </button>
              {expanded[c.conversation_id] && (
                <div className="mt-3 space-y-2 border-t border-black/5 pt-3">
                  {(c.messages || []).map((m, i) => (
                    <div key={i} className={`rounded-xl px-3 py-2 text-sm ${
                      m.role === "user" ? "bg-[#4361EE]/10 text-black/80" : "bg-[#F72585]/10 text-black/80"
                    }`}>
                      <div className="text-[10px] font-black uppercase text-black/50 mb-0.5">{m.role}</div>
                      <div className="whitespace-pre-wrap">{m.content}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
